var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "nudge-width": 280,
        "offset-y": "",
        left: "",
        "max-width": 320,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [
                _vm._t(
                  "activator",
                  function () {
                    return [
                      _c(
                        "v-avatar",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "cursor-pointer",
                              attrs: {
                                size: _vm.avatarSize,
                                color: _vm.avatarColor,
                              },
                            },
                            "v-avatar",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _vm.teacher && _vm.teacher.photo
                            ? _c("v-img", { attrs: { src: _vm.teacher.photo } })
                            : _c(
                                "v-icon",
                                { attrs: { color: _vm.iconColor } },
                                [_vm._v("mdi-account")]
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                  { on: on, attrs: attrs }
                ),
              ]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "teacher-quick-view" },
        [
          _vm.loading
            ? [
                _c(
                  "v-card-text",
                  [
                    _c("v-skeleton-loader", {
                      attrs: {
                        type: "list-item-avatar-two-line, divider, list-item-two-line",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.teacherData
            ? [
                _c(
                  "v-card-title",
                  { staticClass: "pb-0" },
                  [
                    _c(
                      "v-avatar",
                      {
                        staticClass: "mr-3",
                        attrs: { size: "48", color: "grey lighten-2" },
                      },
                      [
                        _vm.teacherData.photo
                          ? _c("v-img", {
                              attrs: { src: _vm.teacherData.photo },
                            })
                          : _c("v-icon", { attrs: { color: "grey" } }, [
                              _vm._v("mdi-account"),
                            ]),
                      ],
                      1
                    ),
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "subtitle-1 font-weight-medium" },
                        [_vm._v(_vm._s(_vm.teacherData.name))]
                      ),
                      _vm.teacherData.registration
                        ? _c("div", { staticClass: "caption grey--text" }, [
                            _vm._v(
                              " Matrícula: " +
                                _vm._s(_vm.teacherData.registration) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _c(
                  "v-card-text",
                  { staticClass: "pt-2" },
                  [
                    _vm.teacherData.status
                      ? _c(
                          "v-chip",
                          {
                            staticClass: "mb-2",
                            attrs: {
                              "x-small": "",
                              color: _vm.teacherData.status.active
                                ? "success"
                                : "grey",
                              dark: "",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.teacherData.status.name || "Ativo") +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("v-divider", { staticClass: "my-2" }),
                    _c(
                      "v-list",
                      { staticClass: "pa-0", attrs: { dense: "" } },
                      [
                        _vm.teacherData.email
                          ? _c(
                              "v-list-item",
                              {
                                staticClass: "px-0",
                                on: {
                                  click: function ($event) {
                                    return _vm.copyToClipboard(
                                      _vm.teacherData.email
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  { staticClass: "mr-2" },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "grey" } },
                                      [_vm._v("mdi-email")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-2" },
                                      [_vm._v(_vm._s(_vm.teacherData.email))]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          "x-small": "",
                                          color: "grey lighten-1",
                                        },
                                      },
                                      [_vm._v("mdi-content-copy")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.teacherData.mobile_phone
                          ? _c(
                              "v-list-item",
                              {
                                staticClass: "px-0",
                                on: {
                                  click: function ($event) {
                                    return _vm.copyToClipboard(
                                      _vm.teacherData.mobile_phone
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  { staticClass: "mr-2" },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "grey" } },
                                      [_vm._v("mdi-phone")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-2" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.teacherData.mobile_phone)
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          "x-small": "",
                                          color: "grey lighten-1",
                                        },
                                      },
                                      [_vm._v("mdi-content-copy")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.teacherData.titling
                          ? _c(
                              "v-list-item",
                              { staticClass: "px-0" },
                              [
                                _c(
                                  "v-list-item-icon",
                                  { staticClass: "mr-2" },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "grey" } },
                                      [_vm._v("mdi-school")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-2" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.teacherData.titling.name)
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.teacherData.disciplines &&
                    _vm.teacherData.disciplines.length
                      ? [
                          _c("v-divider", { staticClass: "my-2" }),
                          _c(
                            "div",
                            { staticClass: "caption grey--text mb-1" },
                            [_vm._v("Disciplinas")]
                          ),
                          _c(
                            "v-chip-group",
                            { attrs: { column: "" } },
                            [
                              _vm._l(
                                _vm.teacherData.disciplines.slice(0, 5),
                                function (discipline) {
                                  return _c(
                                    "v-chip",
                                    {
                                      key: discipline.id,
                                      attrs: { "x-small": "", outlined: "" },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(discipline.name) + " "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm.teacherData.disciplines.length > 5
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        color: "grey",
                                        "text-color": "white",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " +" +
                                          _vm._s(
                                            _vm.teacherData.disciplines.length -
                                              5
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("v-divider"),
                _c(
                  "v-card-actions",
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "", small: "", color: "primary" },
                        on: { click: _vm.viewFullProfile },
                      },
                      [
                        _c("v-icon", { attrs: { small: "", left: "" } }, [
                          _vm._v("mdi-account-details"),
                        ]),
                        _vm._v(" Ver Perfil Completo "),
                      ],
                      1
                    ),
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function ($event) {
                            _vm.menu = false
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("mdi-close"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "v-card-text",
                  { staticClass: "text-center py-4" },
                  [
                    _c("v-icon", { attrs: { color: "grey lighten-1" } }, [
                      _vm._v("mdi-account-off"),
                    ]),
                    _c("div", { staticClass: "caption grey--text mt-1" }, [
                      _vm._v("Informações não disponíveis"),
                    ]),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
      _c("emc-alert-snackbar", {
        attrs: {
          show: !!_vm.snackbarMessage,
          message: _vm.snackbarMessage,
          color: "success",
        },
        on: {
          "update:show": function ($event) {
            _vm.snackbarMessage = ""
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }